export const coreRoutes = [
  {
    path: '/mis-licencias',
    name: 'MisLicencias',
    component: () => import('@/modules/Configuracion/views/Licencia/MisLicenciasView.vue'),
    menu: false,
    desplegable: false,
    meta: {
      title: 'Mis licencias',
      requiresSession: true,
      permiso: [],
      perfiles: []
    },
    children: []
  },
  {
    path: '/error403',
    name: 'Acceso denegado',
    component: () =>
      import(
        /* webpackChunkName: "base" */ '@/modules/Core/views/AccessDenied.vue'
      ),
    icon: 'QueueListIcon',
    menu: false,
    desplegable: false,
    meta: {
      title: 'Acceso denegado',
      requiresSession: true,
      permiso: []
    },
    children: []
  },
  {
    path: '/inicio',
    name: 'Inicio',
    desplegable: false,
    icon: 'mdiHomeHeart',
    typeIcon: 'mdi',
    menu: true,
    meta: {
      permiso: [],
      title: 'Inicio',
      requiresSession: true,
      showBackButton: false
    },
    children: [],
    component: () =>
      import(/* webpackChunkName: "base" */ '@/modules/Core/views/Home.vue')
  },
  {
    path: '/mi-hoja-de-vida',
    name: 'MiHojaDeVida',
    component: () =>
      import(
        /* webpackChunkName: "administracion" */ '@/modules/Administracion/views/Empleados/MiHojaVidaView.vue'
      ),
    icon: 'IdentificationIcon',
    menu: false,
    desplegable: false,
    meta: {
      title: 'Mi hoja de vida',
      requiresSession: true,
      permiso: [],
      perfiles: []
    },
    children: []
  }
]
